<template>
  <div class="image-previewer">
    <transition-group :name="direction" mode="out-in">
      <div
        class="image-wrapper"
        v-for="(image, index) in images"
        v-show="index == activeIndex"
        :key="image.name"
        :title="image.project"
      >
        <img :src="image.url" alt="" />
        <div class="image-name d-none d-xl-block">
          {{ image.project }}
        </div>
      </div>
    </transition-group>

    <div class="project-meter">
      <div class="meter-ball" :style="{ left: progress }"></div>
    </div>

    <div class="action-buttons">
      <div v-if="canShare">
        <button class="btn share-button" @click="share">
          <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
            <path
              d="M 33.140625 3.199219 L 30.933594 5.394531 L 38.023438 12.5 L 31.640625 12.5 C 25 12.5 19.410156 15.417969 15.550781 19.945313 C 11.695313 24.476563 9.496094 30.578125 9.375 37.074219 C 9.375 37.253906 9.375 37.390625 9.375 37.5 L 12.5 37.5 C 12.5 37.339844 12.5 37.21875 12.5 37.144531 C 12.609375 31.296875 14.585938 25.878906 17.921875 21.972656 C 21.265625 18.066406 25.902344 15.625 31.640625 15.625 L 38.023438 15.625 L 30.933594 22.730469 L 33.140625 24.925781 L 44.007813 14.0625 Z M 3.125 12.5 L 3.125 39.0625 C 3.125 41.636719 5.238281 43.75 7.8125 43.75 L 39.0625 43.75 C 41.636719 43.75 43.75 41.636719 43.75 39.0625 L 43.75 28.125 L 40.625 28.125 L 40.625 39.0625 C 40.625 39.941406 39.941406 40.625 39.0625 40.625 L 7.8125 40.625 C 6.933594 40.625 6.25 39.941406 6.25 39.0625 L 6.25 12.5 Z "
            />
          </svg>
        </button>
        <br />
        <small>share</small>
      </div>
      <div v-else>
        <button class="btn share-button" @click="copy">
          <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
            <path
              d="M 7.8125 3.125 C 5.238281 3.125 3.125 5.238281 3.125 7.8125 L 3.125 32.8125 C 3.125 35.386719 5.238281 37.5 7.8125 37.5 L 12.5 37.5 L 12.5 39.0625 C 12.5 41.636719 14.613281 43.75 17.1875 43.75 L 42.1875 43.75 C 44.761719 43.75 46.875 41.636719 46.875 39.0625 L 46.875 14.0625 C 46.875 11.488281 44.761719 9.375 42.1875 9.375 L 37.5 9.375 L 37.5 7.8125 C 37.5 5.238281 35.386719 3.125 32.8125 3.125 Z M 7.8125 6.25 L 32.8125 6.25 C 33.691406 6.25 34.375 6.933594 34.375 7.8125 L 34.375 32.8125 C 34.375 33.691406 33.691406 34.375 32.8125 34.375 L 7.8125 34.375 C 6.933594 34.375 6.25 33.691406 6.25 32.8125 L 6.25 7.8125 C 6.25 6.933594 6.933594 6.25 7.8125 6.25 Z M 37.5 12.5 L 42.1875 12.5 C 43.066406 12.5 43.75 13.183594 43.75 14.0625 L 43.75 39.0625 C 43.75 39.941406 43.066406 40.625 42.1875 40.625 L 17.1875 40.625 C 16.308594 40.625 15.625 39.941406 15.625 39.0625 L 15.625 37.5 L 32.8125 37.5 C 35.386719 37.5 37.5 35.386719 37.5 32.8125 Z "
            />
          </svg>
        </button>
        <br />
        <small>{{ !url ? "copy link" : "copied" }}</small>
      </div>
      <div>
        <button class="btn close-button" @click="$emit('close')">
          &times;
        </button>
        <br />
        <small>close</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    imageIndex(value) {
      this.goToIndex(value);
    }
  },
  data() {
    return {
      xDown: null,
      yDown: null,
      direction: "slide-left",
      progress: 0,
      activeIndex: this.imageIndex || 0,
      url: null
    };
  },
  props: {
    images: {
      type: Array
    },
    imageIndex: {
      type: Number
    },
    category: {
      type: String
    }
  },
  computed: {
    imagesCount() {
      return this.images.length;
    },
    nextIndex() {
      const nextIndex = this.activeIndex + 1;
      // return nextIndex;

      return nextIndex <= this.imagesCount - 1 ? nextIndex : 0;
    },
    prevIndex() {
      const prevIndex = this.activeIndex - 1;
      // return prevIndex;

      return prevIndex >= 0 ? prevIndex : this.imagesCount - 1;
    },
    canShare() {
      return navigator.share ? true : false;
    }
  },
  mounted() {
    document.onkeydown = e => {
      switch (e.keyCode) {
        case 37:
          //left keypress
          this.prev();
          break;
        case 39:
          //right keypress
          this.next();
          break;
        case 27:
          //esc keypress
          this.$emit("close");
          break;
      }
    };
    // Immediately activate the first slide.
    document.addEventListener("touchstart", this.handleTouchStart, false);
    document.addEventListener("touchmove", this.handleTouchMove, false);
    this.goToIndex(this.activeIndex);
  },
  methods: {
    goToIndex(index) {
      this.direction = index > this.activeIndex ? "slide-left" : "slide-right";

      this.progress =
        ((index % this.images.length) / this.imagesCount) * 100 + "%";
      // this.activeIndex = index % this.images.length;
      this.activeIndex = index;
      this.setImageQuery(this.activeIndex);
    },
    next() {
      this.goToIndex(this.nextIndex);
    },
    prev() {
      this.goToIndex(this.prevIndex);
    },
    handleTouchStart(evt) {
      this.xDown = evt.touches[0].clientX;
      this.yDown = evt.touches[0].clientY;
    },
    handleTouchMove(evt) {
      if (!this.xDown || !this.yDown) {
        return;
      }
      var xUp = evt.touches[0].clientX;
      var yUp = evt.touches[0].clientY;
      var xDiff = this.xDown - xUp;
      var yDiff = this.yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        /*most significant*/
        if (xDiff > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else {
        if (yDiff > 0) {
          /* up swipe */
        } else {
          /* down swipe */
        }
      }
      /* reset values */
      this.xDown = null;
      this.yDown = null;
    },
    setImageQuery(index) {
      let image = this.images[index];
      if (image)
        this.$router.replace({
          name: "Designs",
          query: {
            category: this.category,
            image: image.name
          }
        });
    },
    share() {
      navigator
        .share({
          title: document.title,
          url: window.location.href
        })
        .catch(console.error);
    },
    copy() {
      navigator.clipboard.writeText(window.location.href);
      this.url = true;
    }
  },
  beforeDestroy() {
    document.removeEventListener("touchstart", this.handleTouchStart, false);
    document.removeEventListener("touchmove", this.handleTouchMove, false);
  }
};
</script>

<style lang="scss" scoped>
.image-previewer {
  position: fixed;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  text-align: center;
  transform: scale(0.5);
  animation: zoom 0.2s ease forwards;

  @keyframes zoom {
    to {
      transform: scale(1);
    }
  }

  .image-name {
    font-size: 15vw;
    font-weight: 900;
    line-height: 1;
    opacity: 0.2;
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .image-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .project-meter {
    position: absolute;
    bottom: 10vh;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    width: 60vw;
    background: $primary;

    .meter-ball {
      width: 20px;
      height: 20px;
      background: $primary;
      border-radius: 50%;
      position: absolute;
      top: -10px;
      transition: 0.8s left ease;
    }
  }

  .action-buttons {
    position: fixed;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 20px;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 794px) {
      grid-auto-flow: row;
      top: 100px;
      bottom: unset;
      transform: unset;
      left: unset;
      right: 60px;
    }

    button {
      border-radius: 50%;
      height: 50px;
      width: 50px;
      background: whitesmoke;
      z-index: 2;
      transition: 0.2s background ease;
      // display: grid;
      // place-items: center;
      overflow: hidden;

      &:hover,
      &:focus,
      &:active {
        background: $primary;
        color: whitesmoke;
      }
    }

    .share-button {
      &:hover,
      &:focus,
      &:active {
        svg {
          fill: whitesmoke;
        }
      }

      svg {
        height: 100%;
        width: 100%;
        fill: $dark;
      }
    }
  }
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(100%);
}

.slide-left-enter-active {
  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
  // transition-delay: 0.3s;
}

.slide-left-leave-active {
  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
  transform: translateX(-100%);
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter-active {
  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
  // transition-delay: 0.3s;
}

.slide-right-leave-active {
  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
  transform: translateX(100%);
}
</style>
